import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/scene_factory/:code?",
    name: "scene_factory",
    component: () => import("../views/Scene_factory.vue"),
    props: true
  },
  {
    path: "/scene_play/:code?",
    name: "scene_play",
    component: () => import("../views/Scene_play.vue"),
    props: true
  },
];

const router = new VueRouter({
  mode: "hash", // Changé de "history" à "hash" pour éviter les problèmes de serveur
  base: process.env.BASE_URL,
  routes,
});

export default router;
